import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "onScrollToTop", "onScrollFromBottom", "onScrollToBottom", "stickToTop", "topThreshold", "bottomThreshold"];
import styled from 'styled-components';
import { forwardRef, useCallback, useEffect, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Wrapper = styled.div.withConfig({
  displayName: "ScrollWrapper__Wrapper"
})(["flex:1;overflow-y:auto;display:flex;flex-direction:column-reverse;align-self:stretch;padding:8px 0px;"]);
const Spacer = styled.div.withConfig({
  displayName: "ScrollWrapper__Spacer"
})(["flex:1 1 0px;"]);
const ScrollWrapper = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      children,
      onScrollToTop = () => {},
      onScrollFromBottom = () => {},
      onScrollToBottom = () => {},
      stickToTop = null,
      topThreshold = 300,
      bottomThreshold = 300
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [isOnTop, setIsOnTop] = useState(false);
  const [isOnBottom, setIsOnBottom] = useState(true);
  useEffect(() => {
    if (isOnTop) onScrollToTop();
  }, [isOnTop, onScrollToTop]);
  useEffect(() => {
    if (!isOnBottom) {
      onScrollFromBottom();
    } else {
      onScrollToBottom();
    }
  }, [isOnBottom, onScrollToBottom, onScrollFromBottom]);
  const onWrapperScroll = useCallback(e => {
    const {
      scrollHeight,
      clientHeight,
      scrollTop
    } = e.target;
    if (scrollHeight - clientHeight - Math.abs(scrollTop) <= topThreshold) {
      setIsOnTop(true);
    } else {
      setIsOnTop(false);
    }
    if (Math.abs(scrollTop) >= bottomThreshold) {
      setIsOnBottom(false);
    } else {
      setIsOnBottom(true);
    }
  }, [topThreshold, bottomThreshold]);
  useEffect(() => {
    // if ref current and ref is a mutable ref object
    if (ref && typeof ref !== 'function' && ref.current) {
      const {
        current
      } = ref;
      current.addEventListener('scroll', onWrapperScroll, {
        passive: true
      });
      return () => {
        current.removeEventListener('scroll', onWrapperScroll);
      };
    }
  }, [ref, onWrapperScroll]);
  return /*#__PURE__*/_jsxs(Wrapper, Object.assign({
    "data-test-id": "scroll-container"
  }, props, {
    ref: ref,
    children: [/*#__PURE__*/_jsx(Spacer, {}), children, stickToTop]
  }));
});
ScrollWrapper.displayName = 'ScrollWrapper';
export default ScrollWrapper;